import { createRoot } from 'react-dom/client';
import App from './index';
import { initializeLoggerSession } from 'src/logger/session';
import { initializeCloudWatchRum } from 'src/utils/cloudwatch-rum';

// Errors-only RUM v1 (PRD-2905). No-ops when VITE_APP_CLOUDWATCH_RUM_* are unset.
initializeCloudWatchRum();
// Journey + deploy context on the ops logger (also stamps RUM session attrs).
initializeLoggerSession();

const rootElement = document.getElementById('app');

if (rootElement) {
    createRoot(rootElement).render(<App />);
}
